import { useMemo } from 'react';
import { ApolloClient, InMemoryCache, ApolloLink, createHttpLink } from '@apollo/client';
import { createAuthLink } from 'aws-appsync-auth-link';
import { useAuth } from 'react-oidc-context';
import { APPSYNC_URL, APPSYNC_REGION } from '../constants/applications';

const useClient = () => {
  const { user } = useAuth();
  console.log('Auth user:', user);
  const jwt = user?.id_token;

  const client = useMemo(() => {
    if (!jwt) {
      return;
    }

    const customLink = ApolloLink.from([
      createAuthLink({
        url: APPSYNC_URL,
        region: APPSYNC_REGION,
        auth: {
          type: 'AMAZON_COGNITO_USER_POOLS',
          jwtToken: jwt,
        },
      }),
      createHttpLink({
        uri: APPSYNC_URL,
      }),
    ]);

    return new ApolloClient({
      link: customLink,
      cache: new InMemoryCache(),
    });
  }, [jwt]);

  return client;
};

export default useClient;
